import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import process from 'process';
import * as Sentry from '@sentry/react';

window.process = process;

Sentry.init({
  dsn: 'https://662f62e391af582d2ef9279664dfbb57@o4511598918172672.ingest.de.sentry.io/4511598931148880',

  enabled: window.location.hostname !== 'localhost',
  environment: window.location.hostname === 'localhost' ? 'development' : 'production',

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],

  // Capture 100% of errors, 10% of performance traces, 10% of replays
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  beforeSend(event) {
    if (event.request) {
      delete event.request.data;
      delete event.request.cookies;
      if (event.request.headers) {
        delete event.request.headers['Authorization'];
      }
    }
    if (event.extra) {
      delete event.extra.goalDescription;
      delete event.extra.name;
      delete event.extra.pseudonym;
      delete event.extra.email;
    }
    return event;
  },

  ignoreErrors: [
    'FirebaseError: Failed to get document because the client is offline',
    'network request failed',
    'ERR_NETWORK_CHANGED',
    'ERR_INTERNET_DISCONNECTED',
    'AppCheck: Fetch server returned an HTTP error',
    'popup-closed-by-user',
    'cancelled-popup-request',
    'ResizeObserver loop limit exceeded',
  ],

  denyUrls: [
    /js\.paystack\.co/i,
    /www\.google\.com\/recaptcha/i,
    /recaptcha\.net/i,
    /extensions\//i,
    /^chrome:\/\//i,
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // A new version has been fetched and is waiting to activate.
    if (window.confirm('A new version of Veyl is available. Refresh now?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  },
});